
import React from 'react';
import { ChevronRight, Zap } from 'lucide-react';

const Hero: React.FC = () => {
  const handleNavClick = (targetId: string) => {
    const element = document.getElementById(targetId);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative pt-40 pb-20 overflow-hidden min-h-[85vh] flex items-center justify-center">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none opacity-20">
        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-[#c17c0c]/10 blur-[150px] rounded-full mix-blend-screen animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-zinc-800/20 blur-[150px] rounded-full mix-blend-screen"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        
        <div className="inline-flex items-center space-x-2 bg-zinc-900/80 backdrop-blur-sm border border-zinc-800 rounded-full px-4 py-1.5 mb-8 animate-in slide-in-from-top duration-700">
          <Zap size={14} className="text-[#c17c0c] fill-[#c17c0c]" />
          <span className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.2em] text-zinc-300">
            Ciclo Eleitoral 2026 | Acesso Restrito
          </span>
        </div>
        
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-8 tracking-tighter leading-[0.9] uppercase italic text-white">
          Domine o <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c17c0c] to-amber-500">Território.</span><br/>
          Vença a <span className="relative inline-block">
            Eleição.
            <span className="absolute bottom-3 left-0 w-full h-2 bg-[#c17c0c] -z-10 opacity-60"></span>
          </span>
        </h1>
        
        <p className="max-w-2xl mx-auto text-zinc-400 text-lg md:text-xl mb-12 font-light leading-relaxed">
          Guru.voto: A plataforma definitiva de inteligência geoespacial para quem não aceita nada menos que a vitória absoluta.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-20">
          <button 
            onClick={() => handleNavClick('waitlist')}
            className="w-full sm:w-auto bg-gradient-to-r from-[#c17c0c] to-[#a66a0a] hover:from-[#e08e0e] hover:to-[#c17c0c] text-white px-10 py-5 rounded-xl text-lg font-bold uppercase tracking-widest transition-all shadow-[0_0_20px_rgba(193,124,12,0.3)] hover:shadow-[0_0_40px_rgba(193,124,12,0.6)] flex items-center justify-center space-x-2 focus:outline-none group hover:-translate-y-1"
          >
            <span>Aplicar para Waitlist</span>
            <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button 
            onClick={() => handleNavClick('modules')}
            className="w-full sm:w-auto border border-zinc-800 hover:bg-zinc-900 text-white px-10 py-5 rounded-xl text-lg font-bold uppercase tracking-widest transition-all flex items-center justify-center focus:outline-none hover:-translate-y-1"
          >
            Ver Funcionalidades
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 opacity-60 border-t border-zinc-900/50 pt-10 max-w-4xl mx-auto">
          <div>
            <span className="block text-3xl font-bold font-tactical text-white">0.1KM²</span>
            <span className="text-[10px] uppercase font-mono tracking-widest text-zinc-500">Precisão H3</span>
          </div>
          <div>
            <span className="block text-3xl font-bold font-tactical text-white uppercase italic">Hybrid AI</span>
            <span className="text-[10px] uppercase font-mono tracking-widest text-zinc-500">Multi-LLM</span>
          </div>
          <div>
            <span className="block text-3xl font-bold font-tactical text-white">80/20</span>
            <span className="text-[10px] uppercase font-mono tracking-widest text-zinc-500">Sobras</span>
          </div>
          <div>
            <span className="block text-3xl font-bold font-tactical text-white">REAL-TIME</span>
            <span className="text-[10px] uppercase font-mono tracking-widest text-zinc-500">Geodados</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;
